import { Box } from "@mui/material";
import CommonButton from "./Buttons/common-button";

const ChipsBox = ({ itemList,highlightChip='',handleCategoryChange }) => {
  return (
    <Box sx={{ py: "10px" }}>
      {itemList.map((item) => (
        <CommonButton
          style={ highlightChip === item ? 'gradient':'transparent'}
          text={item}
          sx={{
            width: "auto",
            borderRadius: "999px",
            marginRight: "10px",
            padding: "10px",
          }}
          onClick = {() => handleCategoryChange(item)}
        />
      ))}
    </Box>
  );
};

export default ChipsBox;
